import React from "react";

const items = [
  {
    sec: "A",
    title: "Definitions",
    messageOne:
      "Music book™ refers to the Music book™ platform, including its website and mobile applications.",
    messageTwo:
      "User refers to any individual or entity accessing or using Music book™.",
    messageThree:
      "Content includes music, videos, text, images, and any other material available on the platform.",
    messageFour:
      "Service refers to the features and offerings provided by Music book™, including Vodcast (content sharing platform) and Offers & Rewards (advertising for DJs, Bands,Offline Music Classes, Music Job Posts, Buy & Rent Instruments).",
  },
  {
    sec: "B",
    title: "Eligibility",
    messageOne: "You must be at least 13 years old to use Music book™.",
    messageTwo:
      "If you are under 18, you must have parental or legal guardian consent to use the platform.",
    messageThree:
      "By using Music book™, you represent and warrant that you meet these requirements.",
  },
  {
    sec: "C",
    title: "User Accounts",
    messageOne:
      "Users must provide accurate information when creating an account.",
    messageTwo:
      "You are responsible for maintaining the confidentiality of your account and password.",
    messageThree:
      "Music book™ reserves the right to suspend or terminate accounts that violate these terms.",
  },
  {
    sec: "D",
    title: "Content Ownership and Licensing",
    messageOne:
      "Users retain ownership of their original content uploaded to Music book™.",
    messageTwo:
      "By uploading content to Vodcast, you grant Music book™ a non-exclusive, worldwide, royalty-free license to use, display, and distribute the content for promotional and platform-related purposes.",
    messageThree:
      "Users are responsible for ensuring they have the necessary rights to share their content.",
  },
  {
    sec: "E",
    title: "Prohibited Conduct",
    messageOne: "Post content that infringes on intellectual property rights.",
    messageTwo: "Engage in fraudulent, illegal, or harmful activities.",
    messageThree: "Use bots or automated systems to manipulate engagement.",
    messageFour: "Violate community guidelines or harass other users.",
  },
  {
    sec: "F",
    title: "Vodcast (Content Sharing Platform)",
    messageOne:
      "Users can upload and share music-related content, including videos, podcasts, and discussions.",
    messageTwo:
      "Music book™ does not take responsibility for the accuracy or legality of user-generated content.",
    messageThree:
      "Content that violates copyright laws or community standards will be removed without notice.",
  },
  {
    sec: "G",
    title: "Offers & Rewards (Advertising Services)",
    messageOne:
      "DJs, Bands, Offline Music Classes, Music Job Posts, and Buy & Rent Instruments services can be advertised on the platform.",
    messageTwo:
      "Advertisers must provide accurate details about their services.",
    messageThree:
      "Music book™ is not responsible for any disputes or misrepresentations between advertisers and users.",
    messageFour:
      "Any fraudulent or misleading advertisements will be removed, and the advertiser’s account may be suspended.",
  },
  {
    sec: "H",
    title: "Payment and Refund Policy",
    messageOne:
      "Users are required to pay for advertising services on the platform.",
    messageTwo: "All transactions are final, and no refunds are issued.",
    messageThree:
      "Payment disputes must be raised within 7 days of the transaction.",
  },
  {
    sec: "I",
    title: "Termination of Service",
    messageOne:
      "Music book™ reserves the right to terminate or suspend access to users who violate these terms.",
    messageTwo: "Users may also delete their accounts at any time.",
  },
  {
    sec: "J",
    title: "Limitation of Liability",
    messageOne:
      "Music book™ is not liable for any direct, indirect, incidental, or consequential damages resulting from the use of our platform.",
    messageTwo: "We do not guarantee uninterrupted or error-free service.",
  },
  {
    sec: "K",
    title: "Changes to These Terms",
    messageOne:
      "Music book™ reserves the right to update these terms at any time.",
    messageTwo:
      "Users will be notified of significant changes, and continued use of the platform constitutes acceptance of the updated terms.",
  },
  {
    sec: "L",
    title: "Contact us",
    messageOne:
      "For any questions regarding these Terms and Conditions, please contact us at support@musicbook.co.in",
  },
];

export default function NewTerms() {
  return (
    <>
      <hr className="w-full mt-8 border-gray-700 px-32" />
      <section className="w-full mt-8 flex flex-col justify-start align-middle">
        <div className="flex flex-col gap-4 md:px-32 px-2 justify-start align-middle">
          <h1 className="text-xl text-gray-100 font-semibold">
            1.1 Terms & Condition
          </h1>
          <p>
            The Company is Owned by Snow-Zoe Technologies Private Limited, and
            Music book™ is its subsidiary. These Terms and Conditions govern
            your use of our platform and services. By accessing or using Music
            book™, you agree to be bound by these terms.
          </p>
          <div>
            {items.map((item, index) => (
              <>
                <div key={index} className="flex gap-2 text-gray-200 py-3">
                  <span>{item.sec}.</span>
                  <h4>{item.title}</h4>
                </div>
                <ul className="flex list-disc flex-col gap-4">
                  <li
                    className={`ml-9 ${
                      item.messageOne ? "list-disc" : "list-none"
                    }`}
                  >
                    {item.messageOne ? item.messageOne : ""}
                  </li>
                  <li
                    className={`ml-9 ${
                      item.messageTwo ? "list-disc" : "list-none"
                    }`}
                  >
                    {item.messageTwo ? item.messageTwo : ""}
                  </li>
                  <li
                    className={`ml-9 ${
                      item.messageThree ? "list-disc" : "list-none"
                    }`}
                  >
                    {item.messageThree ? item.messageThree : ""}
                  </li>
                  <li
                    className={`ml-9 ${
                      item.messageFour ? "list-disc" : "list-none"
                    }`}
                  >
                    {item.messageFour ? item.messageFour : ""}
                  </li>
                </ul>
              </>
            ))}
          </div>
          <p>
            By using Music book™, you acknowledge that you have read,
            understood, and agree to these Terms and Conditions.
          </p>
        </div>
      </section>
      <hr className="w-full mt-8 border-gray-700 px-32" />
    </>
  );
}
